import { heroImage } from "..//assets//data//siteData";
import { ProductCard } from "../components";
// import ReactGA from "react-ga4";

// ReactGA.initialize("G-54H54WFPYN");
//
// ReactGA.send({ hitType: "pageview", page: window.location.pathname });

function Main(props) {
  return (
    <section className="main">
      <img src={heroImage} alt="hero" className="main__hero" />
      <section className="main__content fadeInLeft">
        <h2 className="main__title">FEATURED COLLECTION</h2>
        <h2 className="main__title">{props.featuredCollectionCat}</h2>

        <section className="main__cards fadeInUp">
          {props.productInfo.map((product) => {
            return (
              <ProductCard
                key={product.id}
                product={product}
                addToCart={props.addToCart}
                handleProductClick={props.handleProductClick}
              />
            );
          })}
        </section>
      </section>
    </section>
  );
}

export default Main;
